import * as React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import request from "../../../utilities/requests";

const NotesDialog = ({ open, close, pairing }) => {
  const { t } = useTranslation();
  const [notes, setNotes] = React.useState("");

  React.useEffect(() => {
    if (pairing && pairing?._id) {
      getNotes();
    }
  }, [pairing]);

  const getNotes = async () => {
    const result = await request(`pairing/notes?pairingId=${pairing._id}`);
    if (result.success) {
      if (result?.notes?.text){
        setNotes(result?.notes?.text);
      } else {
        setNotes("");
      }
    }
  };

  const saveNotes = async () => {
    if (notes === "") {
      close();
      return
    }
    const body = {
      pairingId: pairing._id,
      notes
    }
    const result = await request('pairing/notes', "post", body);
    if (!result?.success) {
      alert(result.error);
    }
    close()
  }

  return (
    <Dialog open={open} onClose={() => close()} fullWidth>
      <DialogTitle id="alert-dialog-title">{t('event.notes.label')}</DialogTitle>
      <DialogContent>
        <TextField
          label={t('event.notes.label')}
          multiline
          rows={10}
          fullWidth
          style={{ marginTop: 10 }}
          value={notes}
          onChange={(e) =>  setNotes(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          {t('dialog.cancel.button')}
        </Button>
        <Button onClick={() => saveNotes()} autoFocus>
          {t('dialog.save.button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesDialog;
